//
// CONFIGURATION
//
// key: {
//   editor: default | book | instagram | coupon | new,
//   source: photos | instagram | ancestry | calendar,
//   preview: default | book | book-complex | polotno | calendar,
//   numberOfPages: { xs: 1 },
//   fullColWidth: false,
//   withQualityCheck: false,
// }
//
// 'key' - String, represents sku
// 'editor' - String - default is "new"
// 'source' - Combined only with new editor. String, for source selection - default is "photos"
// 'preview' - Combined only with new editor. String, for print preview - default is "default"
// 'numberOfPages' - Object, default is { xs: 2 }
// 'fullColWidth' - Bool, maximum page width of Col, default is false
// 'withQualityCheck' - Bool, show quality of photos indicator, default is false
// 'requiredPhotos' - Bool, defines that all of photos are required, default is true
// 'requiredTexts' - Bool, defines that all of texts are required, default is false
// 'withMultiProductDesignSelect' - Bool, when true, editor tries to group alternatives by themes (FHP). default is false.
// 'devices' - Array, defines users device which is allowed to use this editor, default is ["mobile", "tablet", "desktop"]
// 'versions' - Object, defines overrides for each custom version.
// 'withPolotnoBackgrounds' - Polotno editor will offer backgrounds section. Default is undefined
// 'withPolotnoEmbellish' - Polotno editor will offer embellish section. Default is true.
// 'withPolotnoAncestry' - Polotno editor will offer ancestry section. Default is true.
// 'withPolotnoSettings' - Polotno editor will offer settings section. Default is undefined
// 'withoutFirstBlankPage' - Book editor will not show blank page in thumbs. Default is undefined.
// 'numberOfGenerations' - Number, temp var - It defines default number of generations, in the future user will choose this value.
// 'numberOfMonths' - Number. It defines default number of months in calendar. Default is 12.
//

const numberOfPagesForMultiPhotoProduct = { xs: 2, sm: 2, md: 3, lg: 4, xl: 4 };
const numberOfPagesForCalendars = { xs: 2, sm: 2, md: 3, lg: 3, xl: 3 };

const PRODUCT_EDITOR_CONFIG = {
  'engineer-print': {
    withQualityCheck: true,
  },
  'engineer-print-calendar': {
    withQualityCheck: true,
  },

  'desktop-calendar': {
    numberOfPages: numberOfPagesForCalendars,
    fullColWidth: true,
  },

  'fh-calendar': {
    source: 'calendar',
    preview: 'calendar',
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    contentOptions: {
      events: ['ancestry', 'holidays', 'creations', 'classic', 'custom'],
    },
    requiredPhotos: false,
    withPolotnoBackgrounds: true,
  },

  'fh-standard-hardcover_book-11x8-custom': {
    source: 'ancestry',
    setupSource: 'v2',
    // Temporary setup step "Book design" while the redesigned template is in beta.
    bookDesigns: { current: '4.0.0', new: '5.0.0' },
    preview: 'book-complex',
    requiredPhotos: false,
    devices: ['desktop'],
    contentOptions: {
      page: [
        'blank',
        'title',
        'table-of-contents',
        'index',
        'personal-timeline',
        'family-sheet',
        'record',
        // 'story',
      ],
      person: ['family-tree', 'person'],
    },
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
    withPolotnoSettings: true,
    versions: {
      '1.0.0': {
        withPolotnoBackgrounds: false,
      },
      '2.0.0': {
        withPolotnoBackgrounds: false,
      },
    },
  },

  'fh-standard-hardcover_book-11x8-leather-black': {
    source: 'ancestry',
    setupSource: 'v2',
    // Temporary setup step "Book design" while the redesigned template is in beta.
    bookDesigns: { current: '4.0.0', new: '5.0.0' },
    preview: 'book-complex',
    requiredPhotos: false,
    devices: ['desktop'],
    contentOptions: {
      page: [
        'blank',
        'title',
        'table-of-contents',
        'index',
        'personal-timeline',
        'family-sheet',
        'record',
        // 'story',
      ],
      person: ['family-tree', 'person'],
    },
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
    withPolotnoSettings: true,
    versions: {
      '1.0.0': {
        withPolotnoBackgrounds: false,
      },
      '2.0.0': {
        withPolotnoBackgrounds: false,
      },
    },
  },

  'fh-standard-hardcover_book-11x8-leather-tan': {
    source: 'ancestry',
    setupSource: 'v2',
    // Temporary setup step "Book design" while the redesigned template is in beta.
    bookDesigns: { current: '4.0.0', new: '5.0.0' },
    preview: 'book-complex',
    requiredPhotos: false,
    devices: ['desktop'],
    contentOptions: {
      page: [
        'blank',
        'title',
        'table-of-contents',
        'index',
        'personal-timeline',
        'family-sheet',
        'record',
        // 'story',
      ],
      person: ['family-tree', 'person'],
    },
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
    withPolotnoSettings: true,
    versions: {
      '1.0.0': {
        withPolotnoBackgrounds: false,
      },
      '2.0.0': {
        withPolotnoBackgrounds: false,
      },
    },
  },

  'fh-standard-hardcover_book-13x10-custom': {
    source: 'ancestry',
    setupSource: 'v2',
    // Temporary setup step "Book design" while the redesigned template is in beta.
    bookDesigns: { current: '2.0.0', new: '3.0.0' },
    preview: 'book-complex',
    requiredPhotos: false,
    devices: ['desktop'],
    contentOptions: {
      page: [
        'blank',
        'title',
        'table-of-contents',
        'index',
        'personal-timeline',
        'family-sheet',
        'record',
      ],
      person: ['family-tree', 'person'],
    },
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
    withPolotnoSettings: true,
  },

  'fh-standard-hardcover_book-13x10-leather-black': {
    source: 'ancestry',
    setupSource: 'v2',
    // Temporary setup step "Book design" while the redesigned template is in beta.
    bookDesigns: { current: '2.0.0', new: '3.0.0' },
    preview: 'book-complex',
    requiredPhotos: false,
    devices: ['desktop'],
    contentOptions: {
      page: [
        'blank',
        'title',
        'table-of-contents',
        'index',
        'personal-timeline',
        'family-sheet',
        'record',
      ],
      person: ['family-tree', 'person'],
    },
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
    withPolotnoSettings: true,
  },

  'fh-standard-hardcover_book-13x10-leather-tan': {
    source: 'ancestry',
    setupSource: 'v2',
    // Temporary setup step "Book design" while the redesigned template is in beta.
    bookDesigns: { current: '2.0.0', new: '3.0.0' },
    preview: 'book-complex',
    requiredPhotos: false,
    devices: ['desktop'],
    contentOptions: {
      page: [
        'blank',
        'title',
        'table-of-contents',
        'index',
        'personal-timeline',
        'family-sheet',
        'record',
      ],
      person: ['family-tree', 'person'],
    },
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
    withPolotnoSettings: true,
  },

  'fhp-20x16': {
    source: 'ancestry',
    requiredPhotos: false,
    withMultiProductDesignSelect: true,
    devices: ['desktop'],
  },

  'fhp-24x18': {
    source: 'ancestry',
    requiredPhotos: false,
    withMultiProductDesignSelect: true,
    devices: ['desktop'],
  },

  'fhp-24x36': {
    source: 'ancestry',
    requiredPhotos: false,
    withMultiProductDesignSelect: true,
    devices: ['desktop'],
  },

  'fhp-36x24': {
    source: 'ancestry',
    requiredPhotos: false,
    withMultiProductDesignSelect: true,
    devices: ['desktop'],
  },

  'fhp-36x48': {
    source: 'ancestry',
    requiredPhotos: false,
    withMultiProductDesignSelect: true,
    devices: ['desktop'],
  },

  'fhp-20x16-4g-combo': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '20x16'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-24x18-3g-desc': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '24x18'],
    withPolotnoBackgrounds: true,
    withPolotnoEmbellish: true,
  },

  'fhp-24x18-5g-std': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '24x18'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-24x18-5g-combo': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '24x18'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-24x18-6g-std': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '24x18'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-24x36-7g-std': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '24x36'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-36x24-6g-combo': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '36x24'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-36x24-7g-combo': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '36x24'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-36x24-4g-desc': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '36x24'],
    withPolotnoBackgrounds: true,
    withPolotnoEmbellish: true,
  },

  'fhp-36x48-8g-std': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '18x24'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-36x48-9g-std': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '18x24'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-24x18-5g-fan': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '24x18'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-24x18-6g-fan': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '24x18'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-24x18-7g-fan': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '24x18'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-36x24-8g-fan': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '36x24'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'fhp-36x24-9g-fan': {
    source: 'ancestry',
    setupSource: 'v2',
    preview: 'polotno',
    requiredPhotos: false,
    devices: ['desktop'],
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '36x24'],
    withPolotnoBackgrounds: false,
    withPolotnoEmbellish: true,
  },

  'photolane-hardcover-photo-book': {
    preview: 'book',
  },

  'softcover-photo-book': {
    preview: 'book',
  },

  'photolane-softcover-photo-book': {
    preview: 'book',
  },

  'wall-calendar': {
    numberOfPages: numberOfPagesForCalendars,
    fullColWidth: true,
  },

  'wall-calendar-large': {
    numberOfPages: numberOfPagesForCalendars,
    fullColWidth: true,
  },

  'gallery-wrapped-canvas-8x8': { withQualityCheck: true },
  'gallery-wrapped-canvas-8x10': { withQualityCheck: true },
  'gallery-wrapped-canvas-11x14': { withQualityCheck: true },
  'gallery-wrapped-canvas-12x12': { withQualityCheck: true },
  'gallery-wrapped-canvas-12x36': { withQualityCheck: true },
  'gallery-wrapped-canvas-16x16': { withQualityCheck: true },
  'gallery-wrapped-canvas-16x20': { withQualityCheck: true },
  'gallery-wrapped-canvas-16x24': { withQualityCheck: true },
  'gallery-wrapped-canvas-20x24': { withQualityCheck: true },
  'gallery-wrapped-canvas-20x30': { withQualityCheck: true },
  'gallery-wrapped-canvas-20x60': { withQualityCheck: true },
  'gallery-wrapped-canvas-24x36': { withQualityCheck: true },
  'gallery-wrapped-canvas-30x40': { withQualityCheck: true },
  'gallery-wrapped-canvas-36x36': { withQualityCheck: true },

  'acrylic-print-8x10': { withQualityCheck: true },
  'acrylic-print-11x14': { withQualityCheck: true },
  'acrylic-print-12x12': { withQualityCheck: true },
  'acrylic-print-12x18': { withQualityCheck: true },
  'acrylic-print-16x20': { withQualityCheck: true },
  'acrylic-print-16x24': { withQualityCheck: true },
  'acrylic-print-20x20': { withQualityCheck: true },
  'acrylic-print-20x30': { withQualityCheck: true },
  'acrylic-print-24x36': { withQualityCheck: true },
  'acrylic-print-30x40': { withQualityCheck: true },

  /**
   * COUPON EDITOR
   */
  'giftcard-10': {
    editor: 'coupon',
  },
  'giftcard-25': {
    editor: 'coupon',
  },
  'giftcard-50': {
    editor: 'coupon',
  },
  'giftcard-75': {
    editor: 'coupon',
  },
  'giftcard-100': {
    editor: 'coupon',
  },

  'book-8x8-softcover-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
  },
  'book-8x8-hardcover-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
  },
  'book-8x8-layflat-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    withoutFirstBlankPage: true,
  },
  'book-11x8-layflat-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    withoutFirstBlankPage: true,
  },
  'book-11x8-hardcover-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-11x8-hardcover-linen-gray': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-11x8-hardcover-linen-black': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-11x8-hardcover-linen-cream': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-11x8-hardcover-leather-black': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-11x8-hardcover-leather-tan': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-linen-gray': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-linen-black': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-linen-cream': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-leather-black': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-leather-tan': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },

  "acrylic-magnet-square-small": {
    rowClassName: "justify-content-center",
    numberOfPages: { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 },
  },

  'pexeso': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
    source: 'pexeso',
    editor: 'new',
    preview: 'pexeso',
    requiredPhotos: true,
    uniquePhotos: true,
    withQualityCheck: false,
    embellishCategory: ['Embellishments', 'MyCanvas', 'All', 'avatars'],
  },

  "recprints-small": {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'recprints-large': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  "recprints-small-gloss": {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'recprints-large-gloss': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
};

export const PRODUCT_EDITOR_ALTERNATIVES = [
  [
    'fh-standard-hardcover_book-11x8-leather-black',
    'fh-standard-hardcover_book-11x8-leather-tan',
    'fh-standard-hardcover_book-11x8-custom',
  ],
  [
    'fh-standard-hardcover_book-13x10-leather-black',
    'fh-standard-hardcover_book-13x10-leather-tan',
    'fh-standard-hardcover_book-13x10-custom',
  ],
  ['fhp-20x16', 'fhp-24x18', 'fhp-24x36', 'fhp-36x24', 'fhp-36x48'],
  [
    // 'book-11x8-hardcover-linen-gray',
    // 'book-11x8-hardcover-linen-black',
    // 'book-11x8-hardcover-linen-cream',
    'book-11x8-hardcover-leather-black',
    'book-11x8-hardcover-leather-tan',
  ],
  [
    // 'book-13x10-hardcover-linen-gray',
    // 'book-13x10-hardcover-linen-black',
    // 'book-13x10-hardcover-linen-cream',
    'book-13x10-hardcover-leather-black',
    'book-13x10-hardcover-leather-tan',
  ],
];

export default PRODUCT_EDITOR_CONFIG;
